import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const NumberList = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M4.428 7.256V4.403h-.053l-.91.602V4.06l.963-.644h1.129v3.84z'
          fill='currentColor'
        />
        <path
          d='M9.094 5.216h10.8'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M3.427 14.485v-.73l1.144-1.008q.288-.25.443-.409a1.4 1.4 0 0 0 .215-.269.4.4 0 0 0 .062-.207v-.013a.4.4 0 0 0-.054-.21.33.33 0 0 0-.153-.134.55.55 0 0 0-.236-.047.53.53 0 0 0-.254.06.44.44 0 0 0-.233.401v.023h-1v-.02q0-.387.19-.671.192-.288.533-.445.345-.16.803-.161.445 0 .772.14.329.137.51.39.18.252.181.594v.013q0 .21-.093.42-.09.209-.298.442a5 5 0 0 1-.551.515l-.837.686.306-.468v.468l-.306-.199h1.826v.839z'
          fill='currentColor'
        />
        <path
          d='M9.094 12.416h10.8'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M4.899 20.666q-.447 0-.784-.122a1.3 1.3 0 0 1-.535-.344.9.9 0 0 1-.224-.525l-.003-.028h1.019l.005.026q.015.084.08.153a.45.45 0 0 0 .177.11q.11.039.262.039a.7.7 0 0 0 .26-.042.4.4 0 0 0 .166-.118.28.28 0 0 0 .058-.172v-.004q0-.156-.146-.235-.146-.082-.424-.082h-.375v-.587h.375a1 1 0 0 0 .283-.035.4.4 0 0 0 .176-.103.23.23 0 0 0 .063-.162v-.004a.27.27 0 0 0-.053-.166.33.33 0 0 0-.153-.11.6.6 0 0 0-.235-.04.7.7 0 0 0-.247.043.4.4 0 0 0-.164.115.33.33 0 0 0-.073.172l-.002.02H3.44l.003-.032a.87.87 0 0 1 .207-.513q.184-.216.499-.334.318-.12.741-.12.436 0 .757.105.32.105.494.294a.63.63 0 0 1 .174.442v.004a.56.56 0 0 1-.104.334.8.8 0 0 1-.274.23q-.17.088-.369.12v.018q.414.035.656.214a.56.56 0 0 1 .242.473v.004a.75.75 0 0 1-.192.513 1.2 1.2 0 0 1-.54.334 2.7 2.7 0 0 1-.836.115'
          fill='currentColor'
        />
        <path
          d='M9.094 19.466h10.8'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    ) : (
      <>
        <path
          d='M4.899 19.872q-.447 0-.784-.122a1.3 1.3 0 0 1-.535-.345.9.9 0 0 1-.224-.525l-.003-.027h1.019l.005.025q.015.084.08.153a.44.44 0 0 0 .177.11q.11.04.262.04a.7.7 0 0 0 .26-.042.4.4 0 0 0 .166-.118.28.28 0 0 0 .058-.172v-.005q0-.155-.146-.235-.146-.082-.424-.082h-.375v-.586h.375a1 1 0 0 0 .283-.036.4.4 0 0 0 .176-.103.23.23 0 0 0 .063-.162v-.004a.27.27 0 0 0-.053-.166.33.33 0 0 0-.153-.109.6.6 0 0 0-.235-.04.7.7 0 0 0-.247.042.4.4 0 0 0-.164.116.33.33 0 0 0-.073.172l-.002.019H3.44l.003-.032a.87.87 0 0 1 .207-.512q.184-.217.499-.334.318-.12.741-.12.436 0 .757.105.32.105.494.294a.63.63 0 0 1 .174.441v.005a.56.56 0 0 1-.104.334.8.8 0 0 1-.274.229 1.2 1.2 0 0 1-.369.122v.016q.414.036.656.215a.56.56 0 0 1 .242.472v.005a.75.75 0 0 1-.192.512 1.2 1.2 0 0 1-.54.334 2.7 2.7 0 0 1-.836.116'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.194 18.416c0-.414.403-.75.9-.75h10.8c.497 0 .9.336.9.75s-.403.75-.9.75h-10.8c-.497 0-.9-.336-.9-.75'
          fill='currentColor'
        />
        <path
          d='M4.428 7.256V4.403h-.053l-.91.602V4.06l.963-.644h1.129v3.84z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.194 5.216a.9.9 0 0 1 .9-.9h10.8a.9.9 0 1 1 0 1.8h-10.8a.9.9 0 0 1-.9-.9'
          fill='currentColor'
        />
        <path
          d='M3.427 14.485v-.73l1.144-1.008q.288-.25.443-.409a1.4 1.4 0 0 0 .215-.269.4.4 0 0 0 .062-.207v-.013a.4.4 0 0 0-.054-.21.33.33 0 0 0-.153-.134.55.55 0 0 0-.236-.047.53.53 0 0 0-.254.06.44.44 0 0 0-.233.401v.023h-1v-.02q0-.387.19-.671.192-.288.533-.445.345-.16.803-.161.445 0 .772.14.329.137.51.39.18.252.181.594v.013q0 .21-.093.42-.09.209-.298.442a5 5 0 0 1-.551.515l-.837.686.306-.468v.468l-.306-.199h1.826v.839z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.194 12.416a.9.9 0 0 1 .9-.9h10.8a.9.9 0 0 1 0 1.8h-10.8a.9.9 0 0 1-.9-.9'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
